import {CommentWithTranslation} from '../dashboard/team-results-store';
import {Language} from '../base/label-store';

export const translateComment = (answerWithComment: CommentWithTranslation, language?: Language): string => getTranslation(answerWithComment, language) ?? answerWithComment.text;

const getTranslation = (answerWithComment: CommentWithTranslation, language?: Language): string | undefined => {
    switch (language) {
        case 'et':
            return answerWithComment.textEstonian;
        case 'en':
            return answerWithComment.textEnglish;
        case 'fi':
            return answerWithComment.textFinnish;
        case 'lt':
            return answerWithComment.textLithuanian;
        case 'lv':
            return answerWithComment.textLatvian;
        case 'ru':
            return answerWithComment.textRussian;
        case 'sv':
            return answerWithComment.textSwedish;
        case 'pl':
            return answerWithComment.textPolish;
        case 'ja':
            return answerWithComment.textJapanese;
        case 'vi':
            return answerWithComment.textVietnamese;
        default:
            return answerWithComment.text;
    }
};
